// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as UpdatePasswordRouteImport } from './routes/update-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LearningPathRouteImport } from './routes/learning-path'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EventsRouteImport } from './routes/events'
import { Route as CoursesRouteImport } from './routes/courses'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalSlugRouteImport } from './routes/legal.$slug'
import { Route as CertificateEnrollmentIdRouteImport } from './routes/certificate.$enrollmentId'
import { Route as AuthenticatedStudentRouteImport } from './routes/_authenticated.student'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated.profile'
import { Route as AuthenticatedParentRouteImport } from './routes/_authenticated.parent'
import { Route as AuthenticatedInstructorRouteImport } from './routes/_authenticated.instructor'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated.dashboard'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated.admin'
import { Route as AuthenticatedStudentIndexRouteImport } from './routes/_authenticated.student.index'
import { Route as AuthenticatedStudentResourcesRouteImport } from './routes/_authenticated.student.resources'
import { Route as AuthenticatedStudentQuizzesRouteImport } from './routes/_authenticated.student.quizzes'
import { Route as AuthenticatedStudentCertificatesRouteImport } from './routes/_authenticated.student.certificates'
import { Route as AuthenticatedStudentBadgesRouteImport } from './routes/_authenticated.student.badges'
import { Route as AuthenticatedStudentAssignmentsRouteImport } from './routes/_authenticated.student.assignments'
import { Route as AuthenticatedInstructorIndexRouteImport } from './routes/_authenticated.instructor.index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated.admin.index'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated.admin.users'
import { Route as AuthenticatedAdminTestimonialsRouteImport } from './routes/_authenticated.admin.testimonials'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated.admin.settings'
import { Route as AuthenticatedAdminQuizzesRouteImport } from './routes/_authenticated.admin.quizzes'
import { Route as AuthenticatedAdminProjectsRouteImport } from './routes/_authenticated.admin.projects'
import { Route as AuthenticatedAdminLogsRouteImport } from './routes/_authenticated.admin.logs'
import { Route as AuthenticatedAdminLinksRouteImport } from './routes/_authenticated.admin.links'
import { Route as AuthenticatedAdminLessonsRouteImport } from './routes/_authenticated.admin.lessons'
import { Route as AuthenticatedAdminLearningPathsRouteImport } from './routes/_authenticated.admin.learning-paths'
import { Route as AuthenticatedAdminGroupsRouteImport } from './routes/_authenticated.admin.groups'
import { Route as AuthenticatedAdminEventsRouteImport } from './routes/_authenticated.admin.events'
import { Route as AuthenticatedAdminEnrollmentsRouteImport } from './routes/_authenticated.admin.enrollments'
import { Route as AuthenticatedAdminCoursesRouteImport } from './routes/_authenticated.admin.courses'
import { Route as AuthenticatedAdminContactsRouteImport } from './routes/_authenticated.admin.contacts'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated.admin.blog'
import { Route as AuthenticatedAdminBadgesRouteImport } from './routes/_authenticated.admin.badges'
import { Route as AuthenticatedStudentQuizQuizIdRouteImport } from './routes/_authenticated.student.quiz.$quizId'
import { Route as AuthenticatedStudentLessonLessonIdRouteImport } from './routes/_authenticated.student.lesson.$lessonId'
import { Route as AuthenticatedInstructorGroupGroupIdRouteImport } from './routes/_authenticated.instructor.group.$groupId'
import { Route as AuthenticatedAdminQuestionsQuizIdRouteImport } from './routes/_authenticated.admin.questions.$quizId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const UpdatePasswordRoute = UpdatePasswordRouteImport.update({
            id: '/update-password',path: '/update-password',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LearningPathRoute = LearningPathRouteImport.update({
            id: '/learning-path',path: '/learning-path',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const CoursesRoute = CoursesRouteImport.update({
            id: '/courses',path: '/courses',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LegalSlugRoute = LegalSlugRouteImport.update({
            id: '/legal/$slug',path: '/legal/$slug',getParentRoute: () => rootRouteImport
          })
const CertificateEnrollmentIdRoute = CertificateEnrollmentIdRouteImport.update({
            id: '/certificate/$enrollmentId',path: '/certificate/$enrollmentId',getParentRoute: () => rootRouteImport
          })
const AuthenticatedStudentRoute = AuthenticatedStudentRouteImport.update({
            id: '/student',path: '/student',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedParentRoute = AuthenticatedParentRouteImport.update({
            id: '/parent',path: '/parent',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedInstructorRoute = AuthenticatedInstructorRouteImport.update({
            id: '/instructor',path: '/instructor',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedStudentIndexRoute = AuthenticatedStudentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedStudentRoute
          })
const AuthenticatedStudentResourcesRoute = AuthenticatedStudentResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => AuthenticatedStudentRoute
          })
const AuthenticatedStudentQuizzesRoute = AuthenticatedStudentQuizzesRouteImport.update({
            id: '/quizzes',path: '/quizzes',getParentRoute: () => AuthenticatedStudentRoute
          })
const AuthenticatedStudentCertificatesRoute = AuthenticatedStudentCertificatesRouteImport.update({
            id: '/certificates',path: '/certificates',getParentRoute: () => AuthenticatedStudentRoute
          })
const AuthenticatedStudentBadgesRoute = AuthenticatedStudentBadgesRouteImport.update({
            id: '/badges',path: '/badges',getParentRoute: () => AuthenticatedStudentRoute
          })
const AuthenticatedStudentAssignmentsRoute = AuthenticatedStudentAssignmentsRouteImport.update({
            id: '/assignments',path: '/assignments',getParentRoute: () => AuthenticatedStudentRoute
          })
const AuthenticatedInstructorIndexRoute = AuthenticatedInstructorIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedInstructorRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTestimonialsRoute = AuthenticatedAdminTestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminQuizzesRoute = AuthenticatedAdminQuizzesRouteImport.update({
            id: '/quizzes',path: '/quizzes',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminProjectsRoute = AuthenticatedAdminProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLogsRoute = AuthenticatedAdminLogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLinksRoute = AuthenticatedAdminLinksRouteImport.update({
            id: '/links',path: '/links',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLessonsRoute = AuthenticatedAdminLessonsRouteImport.update({
            id: '/lessons',path: '/lessons',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLearningPathsRoute = AuthenticatedAdminLearningPathsRouteImport.update({
            id: '/learning-paths',path: '/learning-paths',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminGroupsRoute = AuthenticatedAdminGroupsRouteImport.update({
            id: '/groups',path: '/groups',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEventsRoute = AuthenticatedAdminEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEnrollmentsRoute = AuthenticatedAdminEnrollmentsRouteImport.update({
            id: '/enrollments',path: '/enrollments',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCoursesRoute = AuthenticatedAdminCoursesRouteImport.update({
            id: '/courses',path: '/courses',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContactsRoute = AuthenticatedAdminContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBadgesRoute = AuthenticatedAdminBadgesRouteImport.update({
            id: '/badges',path: '/badges',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedStudentQuizQuizIdRoute = AuthenticatedStudentQuizQuizIdRouteImport.update({
            id: '/quiz/$quizId',path: '/quiz/$quizId',getParentRoute: () => AuthenticatedStudentRoute
          })
const AuthenticatedStudentLessonLessonIdRoute = AuthenticatedStudentLessonLessonIdRouteImport.update({
            id: '/lesson/$lessonId',path: '/lesson/$lessonId',getParentRoute: () => AuthenticatedStudentRoute
          })
const AuthenticatedInstructorGroupGroupIdRoute = AuthenticatedInstructorGroupGroupIdRouteImport.update({
            id: '/group/$groupId',path: '/group/$groupId',getParentRoute: () => AuthenticatedInstructorRoute
          })
const AuthenticatedAdminQuestionsQuizIdRoute = AuthenticatedAdminQuestionsQuizIdRouteImport.update({
            id: '/questions/$quizId',path: '/questions/$quizId',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminBadgesRoute: AuthenticatedAdminBadgesRoute,AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRoute,AuthenticatedAdminContactsRoute: AuthenticatedAdminContactsRoute,AuthenticatedAdminCoursesRoute: AuthenticatedAdminCoursesRoute,AuthenticatedAdminEnrollmentsRoute: AuthenticatedAdminEnrollmentsRoute,AuthenticatedAdminEventsRoute: AuthenticatedAdminEventsRoute,AuthenticatedAdminGroupsRoute: AuthenticatedAdminGroupsRoute,AuthenticatedAdminLearningPathsRoute: AuthenticatedAdminLearningPathsRoute,AuthenticatedAdminLessonsRoute: AuthenticatedAdminLessonsRoute,AuthenticatedAdminLinksRoute: AuthenticatedAdminLinksRoute,AuthenticatedAdminLogsRoute: AuthenticatedAdminLogsRoute,AuthenticatedAdminProjectsRoute: AuthenticatedAdminProjectsRoute,AuthenticatedAdminQuizzesRoute: AuthenticatedAdminQuizzesRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminTestimonialsRoute: AuthenticatedAdminTestimonialsRoute,AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminQuestionsQuizIdRoute: AuthenticatedAdminQuestionsQuizIdRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedInstructorRouteChildren = {
  AuthenticatedInstructorIndexRoute: AuthenticatedInstructorIndexRoute,AuthenticatedInstructorGroupGroupIdRoute: AuthenticatedInstructorGroupGroupIdRoute
}

const AuthenticatedInstructorRouteWithChildren = AuthenticatedInstructorRoute._addFileChildren(AuthenticatedInstructorRouteChildren)




const AuthenticatedStudentRouteChildren = {
  AuthenticatedStudentAssignmentsRoute: AuthenticatedStudentAssignmentsRoute,AuthenticatedStudentBadgesRoute: AuthenticatedStudentBadgesRoute,AuthenticatedStudentCertificatesRoute: AuthenticatedStudentCertificatesRoute,AuthenticatedStudentQuizzesRoute: AuthenticatedStudentQuizzesRoute,AuthenticatedStudentResourcesRoute: AuthenticatedStudentResourcesRoute,AuthenticatedStudentIndexRoute: AuthenticatedStudentIndexRoute,AuthenticatedStudentLessonLessonIdRoute: AuthenticatedStudentLessonLessonIdRoute,AuthenticatedStudentQuizQuizIdRoute: AuthenticatedStudentQuizQuizIdRoute
}

const AuthenticatedStudentRouteWithChildren = AuthenticatedStudentRoute._addFileChildren(AuthenticatedStudentRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedInstructorRoute: AuthenticatedInstructorRouteWithChildren,AuthenticatedParentRoute: AuthenticatedParentRoute,AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedStudentRoute: AuthenticatedStudentRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,BlogRoute: BlogRoute,ContactRoute: ContactRoute,CoursesRoute: CoursesRoute,EventsRoute: EventsRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,LearningPathRoute: LearningPathRoute,LoginRoute: LoginRoute,SignupRoute: SignupRoute,UpdatePasswordRoute: UpdatePasswordRoute,VerifyEmailRoute: VerifyEmailRoute,CertificateEnrollmentIdRoute: CertificateEnrollmentIdRoute,LegalSlugRoute: LegalSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)